import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type AvatarGroup from './avatar-group.vue'

export const avatarGroupProps = buildProps({})

export type AvatarGroupProps = ExtractPropTypes<typeof avatarGroupProps>
export type AvatarGroupInstance = InstanceType<typeof AvatarGroup>
